var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _circle, _path55, _path56;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIrecent(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 377,
    height: 377,
    viewBox: "0 0 377 377",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M263.145 264.104C297.964 227.2 241.887 195.733 282.944 152.223C324 108.712 273.742 65.2869 229.889 111.846C185.991 158.336 123.356 151.605 115.933 210.128C109.683 259.278 199.378 331.637 263.145 264.104Z",
    fill: "#7573F5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M241.785 243.081C276.604 206.177 243.599 186.693 280.928 147.505C322.229 104.226 268.813 54.197 226.795 122.255C193.207 176.683 121.228 146.862 113.805 205.386C107.599 254.604 177.949 310.658 241.785 243.081Z",
    fill: "#6A67F5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M192.76 330.229C246.665 295.747 157.199 267.519 207.391 235.412C245.55 211.002 270.68 243.469 318.671 212.769C348.924 193.417 330.954 117.613 281.449 149.281C231.945 180.948 224.856 129.577 177.759 159.705C118.216 197.794 171.742 220.429 125.676 249.897C80.0911 279.057 137.55 365.547 192.76 330.229Z",
    fill: "#90D5C7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M192.819 330.17C239.229 300.481 124.485 269.24 182.313 234.379C245.455 196.313 270.738 243.41 318.73 212.71C348.982 193.358 331.012 117.554 281.508 149.222C188.825 208.51 212.608 137.39 177.817 159.646C118.275 197.735 171.801 220.369 125.735 249.838C80.1496 278.998 137.608 365.488 192.819 330.17Z",
    fill: "#00C2A8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M193.456 263.24H77.4256C75.255 263.24 73.5037 261.489 73.5037 259.319V102.2C73.5037 100.03 75.255 98.2792 77.4256 98.2792H193.481C195.652 98.2792 197.403 100.03 197.403 102.2V259.319C197.403 261.489 195.627 263.24 193.456 263.24Z",
    fill: "white",
    stroke: "#1071E5",
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M187.773 256.42H71.742C69.5714 256.42 67.8201 254.669 67.8201 252.499V95.3803C67.8201 93.2101 69.5714 91.4591 71.742 91.4591H187.797C189.968 91.4591 191.719 93.2101 191.719 95.3803V252.499C191.719 254.669 189.943 256.42 187.773 256.42Z",
    fill: "white",
    stroke: "#1071E5",
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M180.953 248.961H64.9219C62.7513 248.961 61 247.21 61 245.04V87.9212C61 85.751 62.7513 84 64.9219 84H180.977C183.148 84 184.899 85.751 184.899 87.9212V245.04C184.899 247.21 183.123 248.961 180.953 248.961Z",
    fill: "white",
    stroke: "#1071E5",
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M171.234 100.943H74.6653V108.81H171.234V100.943Z",
    fill: "#FCCE14"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M108.944 213.334V179.054H74.6581V213.334H108.944Z",
    fill: "#FCCE14"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M147.184 113.199H98.0242V116.282H147.184V113.199Z",
    fill: "#FCCE14"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M171.234 131.572H87.8862V134.803H171.234V131.572Z",
    fill: "#F2F3F5"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M115.858 136.801H74.6653V140.031H115.858V136.801Z",
    fill: "#F2F3F5"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M122.937 147.232H74.6653V150.463H122.937V147.232Z",
    fill: "#F2F3F5"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M149.306 136.801H120.125V140.031H149.306V136.801Z",
    fill: "#F2F3F5"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M171.209 136.801H152.537V140.031H171.209V136.801Z",
    fill: "#F2F3F5"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M171.209 142.029H162.379V145.259H171.209V142.029Z",
    fill: "#F2F3F5"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M83.4959 131.572H74.6653V134.803H83.4959V131.572Z",
    fill: "#F2F3F5"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M171.209 147.232H150.564V150.463H171.209V147.232Z",
    fill: "#F2F3F5"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M158.827 142.029H99.3562V145.259H158.827V142.029Z",
    fill: "#F2F3F5"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M94.4971 142.029H74.6653V145.259H94.4971V142.029Z",
    fill: "#F2F3F5"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M146.839 147.232H127.007V150.463H146.839V147.232Z",
    fill: "#F2F3F5"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M74.6435 156.388L157.991 156.388L157.991 153.158L74.6435 153.158L74.6435 156.388Z",
    fill: "#F2F3F5"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M130.016 161.604L171.208 161.604L171.208 158.373L130.016 158.373L130.016 161.604Z",
    fill: "#F2F3F5"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M122.948 172.059L171.22 172.059L171.22 168.829L122.948 168.829L122.948 172.059Z",
    fill: "#F2F3F5"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M96.5765 161.604L125.757 161.604L125.757 158.373L96.5765 158.373L96.5765 161.604Z",
    fill: "#F2F3F5"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M74.6513 161.604L93.3237 161.604L93.3237 158.373L74.6513 158.373L74.6513 161.604Z",
    fill: "#F2F3F5"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M74.6579 166.844L83.4885 166.844L83.4885 163.613L74.6579 163.613L74.6579 166.844Z",
    fill: "#F2F3F5"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M162.388 156.388L171.219 156.388L171.219 153.158L162.388 153.158L162.388 156.388Z",
    fill: "#F2F3F5"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M74.6555 172.059L95.3013 172.059L95.3013 168.829L74.6555 168.829L74.6555 172.059Z",
    fill: "#F2F3F5"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M87.0398 166.844L146.51 166.844L146.51 163.613L87.0398 163.613L87.0398 166.844Z",
    fill: "#F2F3F5"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M151.391 166.844L171.223 166.844L171.223 163.613L151.391 163.613L151.391 166.844Z",
    fill: "#F2F3F5"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M99.0225 172.059L118.854 172.059L118.854 168.829L99.0225 168.829L99.0225 172.059Z",
    fill: "#F2F3F5"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M74.6435 223.172L157.991 223.172L157.991 219.941L74.6435 219.941L74.6435 223.172Z",
    fill: "#F2F3F5"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M130.016 228.412L171.208 228.412L171.208 225.182L130.016 225.182L130.016 228.412Z",
    fill: "#F2F3F5"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M122.948 238.843L171.22 238.843L171.22 235.613L122.948 235.613L122.948 238.843Z",
    fill: "#F2F3F5"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M96.5765 228.412L125.757 228.412L125.757 225.182L96.5765 225.182L96.5765 228.412Z",
    fill: "#F2F3F5"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M74.6513 228.412L93.3237 228.412L93.3237 225.182L74.6513 225.182L74.6513 228.412Z",
    fill: "#F2F3F5"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M74.6579 233.628L83.4885 233.628L83.4885 230.397L74.6579 230.397L74.6579 233.628Z",
    fill: "#F2F3F5"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M162.388 223.172L171.219 223.172L171.219 219.941L162.388 219.941L162.388 223.172Z",
    fill: "#F2F3F5"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M74.6555 238.843L95.3013 238.843L95.3013 235.613L74.6555 235.613L74.6555 238.843Z",
    fill: "#F2F3F5"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M87.0398 233.628L146.51 233.628L146.51 230.397L87.0398 230.397L87.0398 233.628Z",
    fill: "#F2F3F5"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M151.391 233.628L171.223 233.628L171.223 230.397L151.391 230.397L151.391 233.628Z",
    fill: "#F2F3F5"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M99.0225 238.843L118.854 238.843L118.854 235.613L99.0225 235.613L99.0225 238.843Z",
    fill: "#F2F3F5"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M162.848 187.85H119.78V189.946H162.848V187.85Z",
    fill: "#1071E5"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M116.45 190.045C117.077 190.045 117.585 189.537 117.585 188.91C117.585 188.284 117.077 187.776 116.45 187.776C115.823 187.776 115.315 188.284 115.315 188.91C115.315 189.537 115.823 190.045 116.45 190.045Z",
    fill: "#1071E5"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M156.311 193.004H119.78V195.1H156.311V193.004Z",
    fill: "#1071E5"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M116.45 195.199C117.077 195.199 117.585 194.691 117.585 194.065C117.585 193.438 117.077 192.93 116.45 192.93C115.823 192.93 115.315 193.438 115.315 194.065C115.315 194.691 115.823 195.199 116.45 195.199Z",
    fill: "#1071E5"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M151.871 198.183H119.78V200.279H151.871V198.183Z",
    fill: "#1071E5"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M116.45 200.353C117.077 200.353 117.585 199.845 117.585 199.219C117.585 198.592 117.077 198.084 116.45 198.084C115.823 198.084 115.315 198.592 115.315 199.219C115.315 199.845 115.823 200.353 116.45 200.353Z",
    fill: "#1071E5"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M159.567 203.337H119.78V205.434H159.567V203.337Z",
    fill: "#1071E5"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M116.45 205.507C117.077 205.507 117.585 205 117.585 204.373C117.585 203.747 117.077 203.239 116.45 203.239C115.823 203.239 115.315 203.747 115.315 204.373C115.315 205 115.823 205.507 116.45 205.507Z",
    fill: "#1071E5"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M112.133 123.311H133.741",
    stroke: "#1071E5",
    strokeMiterlimit: 10
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M112.133 94.1111H133.741",
    stroke: "#1071E5",
    strokeMiterlimit: 10
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M171.209 179.046V213.325",
    stroke: "#1071E5",
    strokeMiterlimit: 10
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 180.949,
    cy: 90.9494,
    r: 25.9494,
    fill: "#00C2A8",
    stroke: "white",
    strokeWidth: 4
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M182.667 82.6667C182.667 81.7462 181.92 81 181 81C180.08 81 179.333 81.7462 179.333 82.6667V91.8333L183.022 95.0977C183.682 95.6816 184.682 95.6511 185.305 95.0281L185.331 95.0021C185.999 94.3344 185.979 93.2458 185.287 92.6029L182.667 90.1667V82.6667Z",
    fill: "white"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M166 91C166 82.6667 172.667 76 181 76C189.333 76 196 82.6667 196 91C196 99.3333 189.333 106 181 106C172.667 106 166 99.3333 166 91ZM169.333 91C169.333 97.5 174.5 102.667 181 102.667C187.5 102.667 192.667 97.5 192.667 91C192.667 84.5 187.5 79.3333 181 79.3333C174.5 79.3333 169.333 84.5 169.333 91Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIrecent);
export default __webpack_public_path__ + "static/media/irecent.da33d3ac01d5d13cd31f0ef47cae1e6f.svg";
export { ForwardRef as ReactComponent };